import { useIntl } from 'react-intl';
import { Link, useNavigate } from 'react-router-dom';
import "../../../../../app/modules/styles/index.scss";
import { allMenu, TMenu,  } from '../../../../../app/pages/homepage/listMenu';
import { MenuItem } from './MenuItem';
import { Image } from 'react-bootstrap';
import { KTSVG, toAbsoluteUrl } from '../../../../helpers';
import { checkMenuByPermissions, findMenuAccessAllowed } from '../../../../../app/modules/utils/functionUtils';
import { useEffect } from 'react';
import { KEY_LOCALSTORAGE } from '../../../../../app/modules/auth/core/_consts';

export function MenuInner() {
  const intl = useIntl();
  const checkedMenu = checkMenuByPermissions(allMenu);
  const navigate = useNavigate();

  const handleButtonClick = (module: TMenu) => {
    const selectedMenu = checkedMenu.find((menu) => menu.code === module.code);

    if (selectedMenu) {
      localStorage.setItem(KEY_LOCALSTORAGE.LIST_SUB_MENU, JSON.stringify(selectedMenu.subs));
      navigate(`${module.defaultTo || findMenuAccessAllowed(module.subs || [])?.path || module.path}`);
    }
  };
  
  useEffect(() => {
    const tabList:any = document.querySelector('.header-list-nav');
    const isScroll = tabList.clientWidth < tabList?.scrollWidth;
    const rightArrow = document.querySelector('.header-list-nav-container .arrow-right');
    const leftArrow = document.querySelector('.header-list-nav-container .arrow-left');
    if(isScroll) {
      rightArrow?.classList?.remove("hidden");
      const handleShowIcon = () => {
        if(tabList) {
          if(tabList.scrollLeft >= 20) {
            leftArrow?.classList?.remove("hidden");
          } else {
            leftArrow?.classList?.add("hidden");
          }
  
          const maxScrollValue = tabList.scrollWidth - tabList.clientWidth - 20;        
          if(tabList.scrollLeft >= maxScrollValue) {
            rightArrow?.classList?.add("hidden");
          } else {
            rightArrow?.classList?.remove("hidden");
          }
        }
      }
      rightArrow?.addEventListener('click', () => {
        if(tabList) {
          tabList.scrollLeft += 100;
          handleShowIcon();
        }
      });
      leftArrow?.addEventListener('click', () => {
        if(tabList) {
          tabList.scrollLeft -= 100;
          handleShowIcon();
        }
      });
      tabList?.addEventListener('scroll', handleShowIcon);
    }
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className='header-brand'>
        <Link className='header-brand-link w-100 flex flex-middle flex-center' to={'/dashboard'}>
          <Image className='spaces w-65' src={toAbsoluteUrl("/media/logos/xHRM.svg")} />
        </Link>
      </div>
      <MenuItem title="" icon="/media/icons/menu.svg" to="/client-admin" />
      <div className="header-list-nav-container">
        <KTSVG path='/media/icons/arrow-left.svg' className="text-white arrow-left hidden" svgClassName={`position-absolute`}/>
        <div className="header-list-nav">
          {checkedMenu?.map((item: TMenu, index: number) => {
            return (
              <MenuItem 
                key={index} 
                title={intl.formatMessage({ id: item?.name })} 
                to={item.path} 
                onClick={() => handleButtonClick(item)} 
              />
            )
          })}
        </div>
        <KTSVG path='/media/icons/arrow-left.svg' className="text-white arrow-right hidden" svgClassName={`position-absolute`}/>
      </div>
    </div>
  );
}
